// extracted by mini-css-extract-plugin
export var button = "_cr-4";
export var hasDarkBackground = "_cr-7";
export var hasLightBackground = "_cr-6";
export var iconWrapper = "_cr-0";
export var large = "_cr-2";
export var medium = "_cr-1";
export var small = "_cr-5";
export var xsmall = "_cr-3";